import _ from 'lodash';

import {VIEW_NAMES_ENUM} from '../pojos/ViewNames';

export const PRE_RECEIVE_URL = 'pre';
export const PRE_RECEIVE_WORK_VIEW_URL = 'pre-work';
export const POST_RECEIVE_URL = 'post';
export const POST_RECEIVE_WORK_VIEW_URL = 'post-work';
export const DWELL_TIME_URL = 'dwell';
export const SEARCH = 'search';
export const WAREHOUSE_ID_KEY = ':warehouseId';

export const HOME_URL = '/';
export const WAREHOUSE_ID_URL = `/${WAREHOUSE_ID_KEY}`;
export const SEARCH_URL = `${WAREHOUSE_ID_URL}/${SEARCH}`;
export const AGGREGATE_VIEW_URL = `${WAREHOUSE_ID_URL}/:receive(${PRE_RECEIVE_URL}|${POST_RECEIVE_URL}|${DWELL_TIME_URL})`;
export const WORK_AGGREGATE_VIEW_URL = `${WAREHOUSE_ID_URL}/:receive(${PRE_RECEIVE_WORK_VIEW_URL}|${POST_RECEIVE_WORK_VIEW_URL})`;
export const DEFAULT_AGGREGATE_VIEW = `${WAREHOUSE_ID_URL}/${PRE_RECEIVE_URL}`;
export const ITEM_LIST_URL = `${WAREHOUSE_ID_URL}/itemList`;

export const RouteUtilities = {
    isSearchView(currentView) {
        return _.includes(_.toLower(currentView), _.toLower(SEARCH));
    },

    isPreReceiveAggregateView(currentView) {
        return _.includes([
            VIEW_NAMES_ENUM.PRE_RECEIVE,
            VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW
        ], currentView);
    },

    isPostReceiveAggregateView(currentView) {
        return _.includes([
            VIEW_NAMES_ENUM.POST_RECEIVE,
            VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW
        ], currentView);
    },

    isDwellTimeAggregateView(currentView) {
        return currentView === VIEW_NAMES_ENUM.DWELL_TIME;
    },

    isWorkView(currentView) {
        return _.includes([
            VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW,
            VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW
        ], currentView);
    },

    generateNewUrl(warehouseId, view) {
        const urlWarehouseId = !_.isNil(warehouseId) ? `/${warehouseId}` : '';
        const urlView = !_.isNil(view) ? `/${view}` : '';

        return `${urlWarehouseId}${urlView}`;
    }
};
